import NotificationStatus from './notification_status';

export default NotificationStatus;
